import { ApiModel } from './api-model';

export class TranslationType extends ApiModel {

  id: string;
  value: string;
  languageId: number;
  translated: number;
  total: number;
  isDashboard: boolean;

  get percentTranslated(): number {

    // if this.total = 0, to avoid division by, return 0
    if (this.total === 0) {
      return 0;
    }
    return Number((this.translated / this.total * 100).toFixed(2));
  }
}


// WEBPACK FOOTER //
// ./src/app/models/translation-type.ts